import styled, { css } from 'styled-components';

export const SIZE = {
  LARGE: 'large',
  SMALL: 'small',
};

const Container = styled.div`
  background: ${({ theme }) => theme.commons.button.secondary.background};
  color: ${({ theme }) => theme.commons.global.textPrimary};
  border-radius: ${({ theme }) => theme.commons.button.secondary.borderRadius};
  display: flex;
  text-align: center;
  margin: 0px;
  overflow: hidden;
  align-items: center;
  span {
    flex: 3;
  }
  ${({ size }) =>
    size === SIZE.SMALL
      ? css`
          width: 90px;
          height: 28px;
          line-height: 16px;
        `
      : css`
          width: 90px;
          height: 52px;
          line-height: 44px;
        `};
`;

export default Container;
